export const TEXT_INPUT_REDUCER_STATE_ID = 'textInput';
export const TEXT_STANDARD_PAGE_LENGTH = 1800;
export const TEXT_MAX_LENGTH = 2 * TEXT_STANDARD_PAGE_LENGTH;
